import { render, staticRenderFns } from "./VAdminCityCard.vue?vue&type=template&id=3385c475"
import script from "./VAdminCityCard.vue?vue&type=script&lang=js"
export * from "./VAdminCityCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports